import * as React from "react";

const Newsletter: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5 22H19C20.6569 22 22 20.6569 22 19V2H6V8H2V18V19H2.09451C2.33745 20.2585 3.02818 21.2773 3.92673 21.7364C3.54494 21.9113 3.2031 22 3 22H5ZM5 14C5.35064 14 5.68722 14.0802 6 14.2276V10H4V14.2276C4.31278 14.0802 4.64936 14 5 14ZM8 19V18V8V4H20V19C20 19.5523 19.5523 20 19 20H10.0878H7.88226C7.9587 19.6786 8 19.3444 8 19ZM13 6H10V10H13V6ZM14 6H18V7.5H14V6ZM18 9H14V10.5H18V9ZM10 12H18V13.5H10V12ZM18 15H10V16.5H18V15Z" fill="currentColor" />
        </svg>
    );
};

export default React.memo(Newsletter);
